import { setTag } from '@sentry/react';
import { v4 as randomUuid } from 'uuid';

const FLOW_ID_KEY = 'flow-id';

let flowId: string | null = null;

/**
 * Groups the requests of one browser tab in the backend and TWINT proxy logs
 * and in Sentry. Kept in sessionStorage so that it survives reloads and the
 * redirects through Datatrans and TWINT.
 */
export function tabFlowId(): string {
    return flowId ?? startFlow(storedFlowId() ?? randomUuid());
}

/**
 * Starts a new flow, so that the next login in this tab does not continue the
 * flow of the previous one.
 */
export function resetTabFlowId(): void {
    startFlow(randomUuid());
}

function startFlow(id: string): string {
    flowId = id;
    try {
        sessionStorage.setItem(FLOW_ID_KEY, id);
    } catch {
        // storage blocked: the id lives as long as the page
    }
    setTag('flow_id', id);
    return id;
}

function storedFlowId(): string | null {
    try {
        return sessionStorage.getItem(FLOW_ID_KEY);
    } catch {
        return null;
    }
}
